import type {
  SupplierAnnouncementCreateRequestType,
  SupplierAnnouncementCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierAnnouncementCreate = (supplierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierAnnouncementCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `suppliers/${supplierId}/supplier-announcement`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierAnnouncementCreateResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierAnnouncement,
          response.id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierAnnouncement,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SuppliersLegacy],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SuppliersLegacy,
          supplierId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Suppliers,
          supplierId,
        ],
      });
    },
  });
};
